/**
 * SectionHeader — Cabeçalho de página/seção
 */
import { T } from '../../styles/tokens';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  action?: any;
}

export function SectionHeader({ title, subtitle, action }: SectionHeaderProps) {
  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
      marginBottom: 28, gap: 20, flexWrap: 'wrap',
    }}>
      <div>
        <h1 style={{
          fontSize: 28, fontWeight: 800, color: T.text,
          margin: 0, letterSpacing: '-0.5px',
        }}>{title}</h1>
        {subtitle && (
          <p style={{ color: T.textMuted, fontSize: 13, margin: '4px 0 0' }}>
            {subtitle}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}
